import React, { Component } from 'react';
import { ShowExpanded, EmailField } from '../shared';

class ContactDetails extends Component {
  constructor() {
    super();
    this.state = { expanded: false };
    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    this.setState(state => ({ expanded: !state.expanded }));
  }
  render() {
    const { contact } = this.props;
    const { expanded } = this.state;

    let details = null;
    if (expanded) {
      details = (
        <div>
          <div className="form-group">
            <label>Adres:</label>
            <span className="form-control">{contact.address1}</span>
          </div>
          <div className="form-group">
            <label>Contactpersoon:</label>
            <span className="form-control">
              {contact.k1PpName || contact.mainCont}
            </span>
          </div>
          <div className="form-group">
            <label>Contactpersoon mob:</label>
            <span className="form-control">{contact.telMob}</span>
          </div>
          <div className="form-group">
            <label>Telefoon:</label>
            <span className="form-control">{contact.telBus}</span>
          </div>
          <EmailField value={contact.mailBus}>E-mail zakelijk:</EmailField>
          <EmailField value={contact.k1Vmail}>
            E-mail contactpersoon:
          </EmailField>
          <div className="form-group">
            <label>Afstand:</label>
            <span className="form-control">{contact.r3Distance}</span>
          </div>
        </div>
      );
    }

    return (
      <div>
        <h4 onClick={this.toggle}>
          <ShowExpanded expanded={expanded} />
          {contact.acctName}
        </h4>
        {details}
      </div>
    );
  }
}

export default ContactDetails;



// WEBPACK FOOTER //
// ./src/contacts/ContactDetails.js